import React from "react";
import useOS from "./hooks/useOS";
import { transformKeys } from "./logic";
import { BaseShortcut, BaseShortcutGroup } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
export default function Shortcuts(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "uiElement" : _ref$variant,
    keys = _ref.keys,
    combineKeys = _ref.combineKeys,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "neutral" : _ref$color;
  var os = useOS();
  var transformedKeys = transformKeys(keys !== null && keys !== void 0 ? keys : [], os);
  if (combineKeys) {
    var keyOccurrences = {};
    return /*#__PURE__*/_jsx(BaseShortcut, {
      separateCombinedKeys: true,
      as: "span",
      variant: variant,
      color: color,
      children: transformedKeys === null || transformedKeys === void 0 ? void 0 : transformedKeys.map(function (key) {
        var _keyOccurrences$key;
        keyOccurrences[key] = ((_keyOccurrences$key = keyOccurrences[key]) !== null && _keyOccurrences$key !== void 0 ? _keyOccurrences$key : 0) + 1;
        var reactKey = "".concat(key, "-").concat(keyOccurrences[key]);
        return /*#__PURE__*/_jsx(React.Fragment, {
          children: /*#__PURE__*/_jsx("kbd", {
            children: key
          })
        }, reactKey);
      })
    });
  }
  return /*#__PURE__*/_jsx(BaseShortcutGroup, {
    children: transformedKeys === null || transformedKeys === void 0 ? void 0 : transformedKeys.map(function (key) {
      return /*#__PURE__*/_jsx(BaseShortcut, {
        variant: variant,
        color: color,
        children: key
      }, key);
    })
  });
}